import { TutorialType } from '@classes/Tutorials/TutorialFactory';
import { ActionTypes } from './types';

export function setActiveTutorial(value?: TutorialType) {
  return { type: ActionTypes.SET_ACTIVE_TUTORIAL, value };
}

export function setTutorialsEnabled(value: boolean) {
  return { type: ActionTypes.SET_TUTORIALS_ENABLED, value }
}